import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { TDateFormat } from '../types';

dayjs.extend(customParseFormat);

export const DEFAULT_DATE_FORMAT: TDateFormat = 'DD/MM/YYYY';

export const getDateFormat = (format = window.DATE_FORMAT): TDateFormat => {
  switch (format) {
    case 'm/d/Y':
      return 'MM/DD/YYYY';
    case 'd/m/Y':
      return DEFAULT_DATE_FORMAT;
    case 'Y/m/d':
      return 'YYYY/MM/DD';
    default:
      return 'DD/MM/YYYY';
  }
};

export function dateToApiaFormat(date: string | Date) {
  return dayjs(date).format(getDateFormat());
}

export function apiaDateToStandarFormat(date: string) {
  const newDate = dayjs(date, getDateFormat());
  if (!newDate.isValid()) return '';
  return newDate.format('YYYY-MM-DD');
}
